<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div
            class="w-100 mb-3 d-flex flex-column flex-md-row align-items-md-center justify-content-md-between"
          >
            <h1>لیست دسته بندی های بلاگ</h1>
            <b-button variant="success" v-b-modal.modal-create-category>
              افزودن دسته بندی جدید
            </b-button>
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="categoriesList"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(actions)="data">
              <feather-icon
                size="20"
                icon="EditIcon"
                style="cursor: pointer"
                class="text-primary"
                @click="setTempBlogCategory(data.item)"
              />
              <feather-icon
                  icon="TrashIcon"
                  size="20"
                  style="cursor: pointer"
                  class="text-danger"
                  @click="setTempBlogCategoryForDelete(data.item)"
              />

            </template>
          </b-table>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
          >
            <b-pagination
                v-model="filters.pageNumber"
              :total-rows="totalCount"
                :per-page="filters.count"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <!-- Category Create Modal Start -->
    <b-modal
      title="ایجاد دسته بندی برای وبلاگ"
      id="modal-create-category"
      centered
      ok-title="ایجاد"
      cancel-title="بستن"
      @ok="createABlogCategory"
    >
      <b-container fluid>
        <b-form-row>
          <b-col cols="12" md="6">
            <b-form-group label="نام دسته بندی" label-for="category-name">
              <b-form-input
                size="sm"
                id="category-name"
                v-model="blogCategoryDetails.title"
                placeholder="آموزش انگلیسی"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group
              label="لینک سئوی دسته بندی"
              label-for="category-seo-url"
            >
              <b-form-input
                size="sm"
                id="category-seo-url"
                placeholder="online-english-learning"
                v-model="allCharactersToDash"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="توضیحات سئوی دسته بندی"
              label-for="category-seo-description"
            >
              <b-form-textarea
                size="sm"
                id="category-seo-description"
                placeholder="یادگیری آنلاین زبان انگلیسی یکی از بهترین روش ها..."
                v-model="blogCategoryDetails.description"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <Uploader
                @getFiles="setCreateImageUrl"
                ref="mainImageUrlCreate"
                label="تصویر دسته بندی"
                :file-type="15"></Uploader>
          </b-col>
        </b-form-row>
      </b-container>
    </b-modal>
    <!-- Category Create Modal End -->
    <!-- Category Edit Modal Start -->
    <b-modal
      title="بروزرسانی دسته بندی وبلاگ"
      id="edit-category-modal"
      centered
      ok-title="بروزرسانی"
      cancel-title="بستن"
      @ok="updateBlogCategory"
    >
      <b-container fluid v-if="tempBlogCategory">
        <b-form-row>
          <b-col cols="12" md="6">
            <b-form-group label="نام دسته بندی" label-for="category-name">
              <b-form-input
                  size="sm"
                  id="category-name"
                  v-model="tempBlogCategory.title"
                  placeholder="آموزش انگلیسی"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group
                label="لینک سئوی دسته بندی"
                label-for="category-seo-url"
            >
              <b-form-input
                  size="sm"
                  id="category-seo-url"
                  placeholder="online-english-learning"
                  v-model="allCharactersToDash2"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="توضیحات سئوی دسته بندی"
                label-for="category-seo-description"
            >
              <b-form-textarea
                  size="sm"
                  id="category-seo-description"
                  placeholder="یادگیری آنلاین زبان انگلیسی یکی از بهترین روش ها..."
                  v-model="tempBlogCategory.description"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <Uploader
                @getFiles="setUpdateImageUrl"
                :default-medias="tempBlogCategory.imageUrl"
                ref="mainImageUrlUpdate"
                label="تصویر دسته بندی"
                :file-type="15"></Uploader>
          </b-col>
        </b-form-row>

      </b-container>
    </b-modal>
    <b-modal
        title="حذف دسته بندی وبلاگ"
        id="delete-category-modal"
        centered
        ok-title="حذف"
        cancel-title="بستن"
        @ok="deleteBlogCategory"
    >
      <b-container fluid v-if="tempBlogCategory">
        <b-form-row>
          <b-col cols="12" md="6">
            <strong>آیا از حذف این دسته بندی اطمینان دارید ؟</strong>
          </b-col>
        </b-form-row>

      </b-container>
    </b-modal>
    <!-- Category Edit Modal End -->
  </b-overlay>
</template>
<script>
import {
  CreateBlogCategory,
  DeleteBlogCategory,
  GetAllBlogCategories,
  UpdateABlogCategory,
} from "@/libs/Api/BlogCategory";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRow,
  BFormTextarea,
  BImg,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Uploader from "@/views/components/Uploader.vue";

export default {
  mounted() {
    this.getAllCategories();
  },
  data() {
    return {
      isLoading: false,
      categoriesList: null,
      categoryValidations: ['title'],
      blogCategoryDetails: {
        title: "",
        description: "",
        imageUrl: "",
        isShowInMain: false,
        seoUrl: "",
        secretKey: ""
      },
      filters: {
        pageNumber: 1,
        count: 10
      },
      totalCount: null,
      tempBlogCategory: null,
      myTableColumns: [
        {
          key: "id",
          label: "شناسه دسته بندی",
        },
        {
          key: "title",
          label: "نام دسته بندی",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  watch: {
    'filters.pageNumber': {
      async handler() {
        this.getAllCategories()
      }
    }
  },
  methods: {
    setCreateImageUrl(medias) {
      if (medias.length) {
        this.blogCategoryDetails.imageUrl = medias[0];
      }
    },
    setUpdateImageUrl(medias) {
      if (medias.length) {
        this.tempBlogCategory.imageUrl = medias[0];
      }
    },
    setTempBlogCategory(category) {
      this.tempBlogCategory = JSON.parse(JSON.stringify(category));
      this.$bvModal.show("edit-category-modal");
    },
    setTempBlogCategoryForDelete(category) {
      this.tempBlogCategory = JSON.parse(JSON.stringify(category));
      this.$bvModal.show("delete-category-modal");
    },

    async deleteBlogCategory() {
      let _this = this;
      try {
        this.isLoading = true;
        let deleteBlogCategory = new DeleteBlogCategory(_this);
        deleteBlogCategory.setParams(_this.tempBlogCategory.id);
        await deleteBlogCategory.fetch(function (response) {
          if (response.isSuccess) {
            _this.getAllCategories();
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "دسته بندی بلاگ با موفقیت حذف شد",
                icon: "PackageIcon",
                variant: "success",
              },
            });
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: response.errorMessage || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateBlogCategory() {
      let isValid = true
      for (let i = 0; i < this.categoryValidations.length; i++) {
        if (!this.tempBlogCategory[this.categoryValidations[i]]) {
          isValid = false;
        }
      }
      if (isValid) {

      let _this = this;

      try {
        this.isLoading = true;
        _this.$refs.mainImageUrlUpdate.getFiles()
        _this.tempBlogCategory['secretKey'] = this.fermanSecretKey
        let updateABlogCategory = new UpdateABlogCategory(_this);
        updateABlogCategory.setRequestParamDataObj(_this.tempBlogCategory);
        await updateABlogCategory.fetch(function (response) {
          if (response.isSuccess) {
            _this.getAllCategories();
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "دسته بندی بلاگ با موفقیت بروزرسانی شد",
                icon: "PackageIcon",
                variant: "success",
              },
            });
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: response.errorMessage || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
      } else {
        _this.$toast({
          component: ToastificationContent,
          props: {
            title: "مشکلی پیش آمد!",
            icon: "XIcon",
            variant: "danger",
            text: 'لطفا فیلدهای اجباری را پر کنید',
          },
        });
      }

    },
    async createABlogCategory() {
      try {
        this.isLoading = true;
        let _this = this;
        let isValid = true
        for (let i = 0; i < this.categoryValidations.length; i++) {
          if (!this.blogCategoryDetails[this.categoryValidations[i]]) {
            isValid = false;
          }
        }
        if (isValid) {

          _this.$refs.mainImageUrlCreate.getFiles()
          _this.blogCategoryDetails.secretKey = this.fermanSecretKey
        let createBlogCategory = new CreateBlogCategory(_this);
        createBlogCategory.setRequestParamDataObj(_this.blogCategoryDetails);
        await createBlogCategory.fetch(function (response) {
          if (response.isSuccess) {
          _this.getAllCategories();
          _this.blogCategoryDetails = {
            title: "",
            description: "",
            imageUrl: "",
            isShowInMain: false,
            seoUrl: "",
            secretKey: ""
          };
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "دسته بندی بلاگ با موفقیت ساخته شد",
                icon: "PackageIcon",
                variant: "success",
              },
            });
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: response.errorMessage || "لطفا دوباره تلاش کنید",
              },
            });
          }
        }, (error) => {
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "مشکلی پیش آمد!",
              icon: "XIcon",
              variant: "danger",
              text: error || "لطفا دوباره تلاش کنید",
            },
          });
        });
        } else {
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "مشکلی پیش آمد!",
              icon: "XIcon",
              variant: "danger",
              text: 'لطفا فیلدهای اجباری را پر کنید',
            },
          });
        }

      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllCategories() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllBlogCategories = new GetAllBlogCategories(_this);
        getAllBlogCategories.setParams(_this.filters)
        await getAllBlogCategories.fetch(function (response) {
          if (response.isSuccess) {
            _this.categoriesList = response.data.data;
            _this.totalCount = response.data.totalCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    fermanSecretKey() {
      return process.env.VUE_APP_BLOG_SECRET
    },
    allCharactersToDash: {
      get: function () {
        return this.blogCategoryDetails.seoUrl;
      },
      set: function (newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.blogCategoryDetails.seoUrl = newValue
          // Remove all characters that are NOT number
          this.blogCategoryDetails.seoUrl = this.blogCategoryDetails.seoUrl.replace(/[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\-/\.]/g, "-");
          this.blogCategoryDetails.seoUrl = this.blogCategoryDetails.seoUrl.replaceAll(' ', '-')
        } else if (!newValue || this.blogCategoryDetails.seoUrl === "") {
          this.blogCategoryDetails.seoUrl = null;
        }
      },
    },
    allCharactersToDash2: {
      get: function () {
        return this.tempBlogCategory.seoUrl;
      },
      set: function (newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.tempBlogCategory.seoUrl = newValue
          // Remove all characters that are NOT number
          this.tempBlogCategory.seoUrl = this.tempBlogCategory.seoUrl.replace(/[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\-/\.]/g, "-");
          this.tempBlogCategory.seoUrl = this.tempBlogCategory.seoUrl.replaceAll(' ', '-')
        } else if (!newValue || this.tempBlogCategory.seoUrl === "") {
          this.tempBlogCategory.seoUrl = null;
        }
      },
    },
  },
  components: {
    Uploader,
    BFormRow,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BFormTextarea,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
